import { render, staticRenderFns } from "./ProgramDashboardV2.vue?vue&type=template&id=2e1794d6&scoped=true"
import script from "./ProgramDashboardV2.vue?vue&type=script&lang=js"
export * from "./ProgramDashboardV2.vue?vue&type=script&lang=js"
import style0 from "./ProgramDashboardV2.vue?vue&type=style&index=0&id=2e1794d6&prod&scoped=true&lang=css"
import style1 from "./ProgramDashboardV2.vue?vue&type=style&index=1&id=2e1794d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1794d6",
  null
  
)

export default component.exports